import React from 'react'
import Title from "../../components/atoms/Title";
import ButtonT from "../../components/atoms/ButtonT";
import Button from "../../components/atoms/Button";
const OrderLogHeader = ({name,status,editOrder,onDelete}) => {
  return (
    
        <div className="flex flex-row justify-between items-center h-10 ">
          <div className="flex flex-row">
          <Title text={`جزئیات سفارش “${name}”`} />
          <span className="text-dark-blue-200 text-13 flex items-center before:content-dot mr-2.5 before:pl-2.5 ">
          {status}
          </span>
          </div>
          
          <div className="flex flex-row gap-3.5">
          <Button text={"ویرایش سفارش"} borderBlue="border-blue border-1" textcolor={" text-dark-blue-200"} onClick={editOrder} />
          <Button text={"حذف سفارش"} borderBlue="border-red border-1" textcolor={"text-red "} onClick={onDelete} />
          <ButtonT text={"برگشت به لیست"} path={"/admin/order"} link={true} />
          </div>
          
        </div>
    
  )
}

export default OrderLogHeader
